import React, { Component } from 'react';
import ComboMenuProcesos from './ComboMenuProcesos';
import ComboIdProcesamiento from './ComboIdProcesamiento'
import SelectorFecha from './SelectorFecha';
import BusquedaArchivos from './BusquedaArchivos';


class ModalEjecucionDemanda extends Component {

    constructor(props) {
        super(props);
        this.limpiarCombos = this.limpiarCombos.bind(this);
    }

    limpiarCombos() {
        this.props.limpiarCombos();
    }

    esProcesoUala(procesos, idProcesoEjecucion) {
        let mostrarSeccionProcesamiento, arrayProcesamiento;

        if (procesos && idProcesoEjecucion)
            arrayProcesamiento = procesos.filter(x => x.Id == idProcesoEjecucion && x.NombreProceso == "CORE_AJUCAR_OUT");

        if (arrayProcesamiento && arrayProcesamiento.length > 0)
            mostrarSeccionProcesamiento = true;
        else
            mostrarSeccionProcesamiento = false;

        return mostrarSeccionProcesamiento;
    }

    esProcesoIIBBLaPampa(procesos, idProcesoEjecucion) {
        let esProcesoLaPampa, arrayProcesamiento;

        if (procesos && idProcesoEjecucion)
            arrayProcesamiento = procesos.filter(x => x.Id == idProcesoEjecucion && x.NombreProceso == "T7740M_OUT");

        if (arrayProcesamiento && arrayProcesamiento.length > 0)
            esProcesoLaPampa = true;
        else
            esProcesoLaPampa = false;

        return esProcesoLaPampa;
    }

    render() {

        const { data, mostrarTablero } = this.props;

        let mostrarSeccionProcesamiento = this.esProcesoUala(data.procesos, data.procesoEjecucion);
        let esProcesoLaPampa = this.esProcesoIIBBLaPampa(data.procesos, data.procesoEjecucion);
        let isProcessSelected = data?.procesoEjecucion != "0"
        let isInputFileType = isProcessSelected && data?.procesos?.filter(x => x.DescripcionProceso == data?.procesoEjecucion)[0]?.TipoProceso ? 
                                                                                data?.procesos?.filter(x => x.DescripcionProceso == data?.procesoEjecucion)[0]?.TipoProceso  == 'I' 
                                                                                : data?.procesosFiltradoEjecucion?.filter(x => x.Descripcion == data?.procesoEjecucion)[0]?.Tipo_Proceso == 'I'
        let showInputFileCombo = isInputFileType
        let extension = data?.procesosFiltradoEjecucion?.filter(x => x.Descripcion == data.procesoEjecucion)[0]?.Extension
        let placeholderSeleccionArchivo = extension ? "Seleccione un archivo con extensi\u00F3n " + extension : "Seleccione un archivo";
        let errorEjecDemanda = data?.procesoEjecucion == '0' || !data?.procesoEjecucion;
 
        errorEjecDemanda = isInputFileType ? data.errorEjecDemanda || !data?.archivoEjecDemandaSeleccionado : errorEjecDemanda;
        
        let errorEjecDemadandaStyle = errorEjecDemanda ? " Procesos-BusquedaArchivoEjecDemanda-BotonDisabled" : "";

        let mensajeError = data && data.msjEjecucionDemanda ?
                                        <div className="Procesos-labelMensajeError">
                                            <label className="error" id="lblError">{data.msjEjecucionDemanda}</label> 
                                        </div>
                                    : 
                                        null

        let elemento = showInputFileCombo
            ?
            <div>
                <div style={{ marginLeft: "42px" }} className='labelComboProcesos'>
                    Archivo
                </div>
                <div className='tableroBodyDemanda'>
                    <BusquedaArchivos placeholder={placeholderSeleccionArchivo} 
                                      listaArchivos={data.archivosEjecDemanda} 
                                      addArchivoEjecucionDemanda={this.props.addArchivoEjecucionDemanda} 
                                      archivoExtension={extension} 
                                      setBusquedaArchivos={this.props.setBusquedaArchivos}
                                      textArchivo={data.textArchivo} />
                </div>
                {mensajeError}
            </div>
            :
            null;

        return (

            <div className='modalContainer'>
                <div className='modalDemandaOut' style={!showInputFileCombo ? { minHeight: '200px' } : null}>
                    {data && data.loadingEjecDemanda && <div id="loading" className="loading" />}
                    <div className='modalDemandaHeader'>
                        <div className='modalProcesosDocumentadosHeaderText'>
                            Ejecución a demanda
                        </div>
                        <label onClick={() => this.limpiarCombos()} className='ti-close clickable modalProcesosClose closeProcesosDemanda'></label>
                    </div>
                    <div className='modalDemandaBody modalProcesosInfoContainer'>
                        <div className="row containerBodyDemanda">
                            <div className="col-md-4">
                                {/*valorActualCombos: diccionario que contiene los valores actuales de los combos Marca y Tipo de Proceso*/}
                                <ComboMenuProcesos 
                                    id={"marcaIdEjecucion"} 
                                    wide={true} 
                                    titulo={"Marca"} 
                                    placeholder={"Todos"} 
                                    nombreAction={"marcaIdEjecucion"} 
                                    selecciones={data} 
                                    selectCombo={this.props.seleccionComboEjecucionDemanda} 
                                    infoData={data.administradoras} 
                                    valorActualCombos={this.props.valorActualCombos}
                                    mostrarTablero={mostrarTablero} />
                            </div>
                            <div className="col-md-4">
                                {/*valorActualCombos: diccionario que contiene los valores actuales de los combos Marca y Tipo de Proceso*/}
                                <ComboMenuProcesos 
                                    id={"tipoProcesoEjecucion"} 
                                    wide={true} 
                                    titulo={"Tipo de Proceso"} 
                                    placeholder={"Todos"} 
                                    nombreAction={"tipoProcesoEjecucion"} 
                                    selecciones={data} 
                                    selectCombo={this.props.seleccionComboEjecucionDemanda} 
                                    infoData={this.props.tiposProceso} 
                                    valorActualCombos={this.props.valorActualCombos}
                                    mostrarTablero={mostrarTablero} />
                            </div>
                            <div className="col-md-4">
                                {/*takePlaceholderValue: Flag que determina si se toma el valor literal de la prop "placeholder" o se deja que la lógica ya existente muestre X valor de placeholder */}
                                <ComboMenuProcesos 
                                    id={"procesoEjecucion"} 
                                    wide={true} 
                                    titulo={"Proceso"} 
                                    placeholder={"Seleccione..."} 
                                    nombreAction={"procesoEjecucion"} 
                                    selecciones={data} 
                                    selectCombo={this.props.seleccionComboEjecucionDemanda} 
                                    infoData={data.procesosFiltradoEjecucion} 
                                    takePlaceholderValue={true} 
                                    administradoraIdSeleccionada={this.props.administradoraIdSeleccionada} 
                                    valorActualCombosProcesos={this.props.valorActualCombos}
                                    mostrarTablero={mostrarTablero} />
                            </div>
                        </div>
                    </div>
                    {mostrarSeccionProcesamiento ?

                        <div className="containerBodyProcesamiento">
                            <div className="top-separator-procesos labelProcesamiento">Información del archivo a regenerar</div>
                            <div className="row containerIdProcesamiento">
                                <div className="col-md-4">
                                    <SelectorFecha errorFormatoFecha={data.errorFormatoFechaEjecDemanda} funcionSeleccion={this.props.funcionSeleccion} maxToday={true} clasePicker="date-picker-ejecucion-demanda" fecha={data.fechaEjecDemanda} fArguments={['fechaEjecDemanda']} titulo="Fecha en que fue generado" />
                                    {data && (data.errorFormatoFechaEjecDemanda || data.esFechaPosteriorEjecDemanda) && <label className="error quitar-margen">{data.msjErrorCalendario}</label>}
                                </div>
                                <div className="col-md-4">
                                    <ComboIdProcesamiento titulo={"ID de Procesamiento"} infoData={data.idsProcesamiento} seleccionIdProceso={this.props.seleccionIdProceso} />
                                    {data && (data.errorFormatoIdProceso || data.errorFormatoIdProceso) && <label className="error quitar-margen">Debe seleccionar un ID.</label>}
                                </div>
                            </div>
                        </div>

                        :
                        <div>
                            {elemento}
                        </div>
                    }
                    <div className='modalProcesosFooterShort'>
                        <button className={"btn btn-cta" + errorEjecDemadandaStyle} onClick={() => { errorEjecDemanda ? null : this.props.ejecutarDtsx(mostrarSeccionProcesamiento, esProcesoLaPampa) }}>Ejecutar ahora</button>
                        <button onClick={() => this.limpiarCombos()} className="btn btn-secondary">Cerrar</button>
                    </div>
                </div>
            </div>
        );
    }
}

export default ModalEjecucionDemanda;